function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22C17.4706 22 22 17.4706 22 12C22 6.53922 17.4608 2 11.9902 2C6.52941 2 2 6.53922 2 12C2 17.4706 6.53922 22 12 22ZM11.9118 8.5098C11.2059 8.5098 10.6373 7.94118 10.6373 7.23529C10.6373 6.51961 11.2059 5.95098 11.9118 5.95098C12.6275 5.95098 13.1863 6.51961 13.1863 7.23529C13.1863 7.94118 12.6275 8.5098 11.9118 8.5098ZM10.2843 17.3922C9.88235 17.3922 9.56863 17.1078 9.56863 16.7059C9.56863 16.3235 9.88235 16.0196 10.2843 16.0196H11.5V11.5196H10.451C10.049 11.5196 9.73529 11.2353 9.73529 10.8333C9.73529 10.451 10.049 10.1471 10.451 10.1471H12.2941C12.7941 10.1471 13.0588 10.5 13.0588 11.0294V16.0196H14.2745C14.6765 16.0196 14.9902 16.3235 14.9902 16.7059C14.9902 17.1078 14.6765 17.3922 14.2745 17.3922H10.2843Z",
  fill: "#878793"
});

function SvgIconInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoCircle);
export default __webpack_public_path__ + "static/media/icon-info-circle.50e97205.svg";
export { ForwardRef as ReactComponent };